import { createReducer, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { login, logout, loginSuccess, loginFail, updateUsername, updatePassword } from '../actions/auth.action';
import { AuthState } from '../../models/auth.model';

export const initialState: AuthState = {
  user: null,
  error: null,
  isLoading: false,
  username: "",
  password: ""
};

export const authReducer = createReducer(
  initialState,
  on(login, (state) => ({ ...state, isLoading: true })),
  on(loginSuccess, (state, { user }) => ({ ...state, user, isLoading: false })),
  on(loginFail, (state, { error }) => ({ ...state, error, isLoading: false })),
  on(logout, state => ({ ...state, user: null })),
  on(updateUsername, (state, { username }) => ({ ...state, username })),
  on(updatePassword, (state, { password }) => ({ ...state, password }))
);




